import api from './utilBackoffice';

const controller = 'Dashboard';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Get: dto => {
    return api.Axios.GetParams(url, dto);
  },
  GetEntradas: dto => {
    return api.Axios.GetParams(url + '/GetEntradas', dto);
  },
  GetCessao: dto => {
    return api.Axios.GetParams(url + '/GetCessao', dto);
  }
});
